(function(angular){
	'use strict';
	
	angular
		.module('starterPortfolioModule')
		.controller('starterPortfolioController', [
			'$scope',
			'globalConfig',
			'localStorageFactory',
			'orderFormFactory',
			'planFactory',
			'urlFactory',
			StarterPortfolioControllerFunction
		]);
	
	function StarterPortfolioControllerFunction(
		$scope,
		globalConfig,
		localStorageFactory,
		orderFormFactory,
		planFactory,
		urlFactory) {

		var starterPortfolio = this;

		starterPortfolio.openAccount = function() {
			orderFormFactory.submitOrderForm(starterPortfolio.starterPortfolioRiaPlanId).then(function() {
				urlFactory.redirect('/reits/signup-checkout/signup');
			});
		};

		$scope.$on('cta:emailSubmitted', function(evt) {
			starterPortfolio.requireEmail = false;
		});

		starterPortfolio.$onInit = function() {
			angular.extend(starterPortfolio, globalConfig);

			var investmentAmount = urlFactory.getUrlParam('investmentAmount');

			if(angular.isDefined(investmentAmount)) {
				starterPortfolio.amount = investmentAmount;
			} else if(angular.isDefined(localStorageFactory.getItem('starterDefaultAmount'))) {
				starterPortfolio.amount = localStorageFactory.getItem('starterDefaultAmount');
			} else {
				if(Math.floor(Math.random() * 2) === 1) {
					starterPortfolio.amount = '1000';
				}
				else {
					starterPortfolio.amount = '10000';
				}
				localStorageFactory.setItem('starterDefaultAmount', starterPortfolio.amount);
			}

			starterPortfolio.requireEmail = urlFactory.getUrlParam('requireEmail') && !localStorageFactory.getItem("emailcapture");
		
			planFactory.getPlanData(['STARTER']).then(function (response) {
				angular.forEach(response.data, function (plan) {
					if (plan.planId === starterPortfolio.starterPortfolioRiaPlanId) {
						starterPortfolio.planData = plan;
					}
				});
			});
		};
	}
})(window.angular);